<template>
  <div>
    <div v-if="!infoOption || infoOption">
      <div class="alginCenterDiv infoDialogRemoveTransition">
        <button
          tabindex="0"
          class="
            text-purple-600
            font-medium
            cursor-pointer
            infoDialogRemoveTransition
            dark:text-white

          "
          style="position: relative; z-index: 5"
          v-on:click="InfoClicked"
          aria-label="What is the Wellness Navigator?"
        >
          What is the Wellness Services Navigator?
        </button>
      </div>
    </div>
    <div v-if="infoOption">
      <div v-on:click="InfoClosed" class="infoOverlay"></div>
    </div>
    <div
      v-if="infoOption"
      style="display: block"
      class="InfoDialog dark:bg-purple-600"
    >
      <div style="display: block; margin-bottom: 15px; z-index: 100">
        <button
          style="float: right; position: relative; z-index: 100"
          v-on:click="InfoClosed"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#F2F2F2" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            />
          </svg>
        </button>
        <div v-if="$store.state.darkMode">
          <div class="newlogoDark"></div>
        </div>
        <div v-else>
          <div class="newlogo"></div>
        </div>
      </div>
      <br />
      <!-- info help part 1 -->
      <div v-if="infoOptions[0] === true">
        <div class="fade">
          <div class="infoPic infoPic1" />
          <div class="alginCenterDiv mt-6">
            <div class="infoTextDialog dark:text-white" role="dialog">
              <h1 class="InfoDialogTitle dark:text-white pb-4">
                What is the Wellness Services Navigator?
              </h1>
              <p class="infoParagraphs dark:text-white">
                The Wellness Services Navigator has been designed to help
                navigate Carleton students to a curated list of mental health
                and wellness resources. When using the Wellness Services
                Navigator, you’ll be asked a series of questions regarding your
                wellness (“How are you feeling today?” “What year are you in?”),
                and at the end, the navigator will suggest some resources that
                are available to you, both on and off campus. A description,
                contact information and a link for each resource will also be
                provided.
              </p>
            </div>
            <button v-on:click="nextInfoOption" class="nextButtonInfo">
              Next
              <span class="arrow">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                    fill="#8380A8"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- info help part 2 -->
      <div v-if="infoOptions[1] === true">
        <div class="fade">
          <div class="infoPic infoPic2"></div>
          <div class="alginCenterDiv mt-6">
            <div class="infoTextDialog dark:text-white" role="dialog">
              <h1 class="InfoDialogTitle dark:text-white pb-4">
                Why should you use it?
              </h1>
              <p class="infoParagraphs">
                The Wellness Services Navigator has been designed to make
                accessing mental health and wellness resources easy, equitable
                and clear. Sometimes students may feel overwhelmed and are not
                sure how to access resources, where to begin, or whether their
                concerns need additional support. We hope that you will use the
                navigator more than once, so that you can see how your
                mood/well-being fluctuates throughout the year depending on
                external or internal stressors in your life.
              </p>
            </div>
            <button v-on:click="nextInfoOption" class="nextButtonInfo">
              Next
              <span class="arrow">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                    fill="#8380A8"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- info help part 3 -->
      <div v-if="infoOptions[2] === true">
        <div class="fade">
          <div class="infoPic infoPic3" />
          <div class="alginCenterDiv mt-6">
            <div class="infoTextDialog dark:text-white" role="dialog">
              <h1 class="InfoDialogTitle dark:text-white pb-4">
                We're here to help!
              </h1>
              <p class="infoParagraphs">
                The Wellness Services Navigator is one tool in the wellness
                toolbox; we hope that you find it useful and clear. Remember,
                all the information you input is completely anonymous. The
                results provided to you are based on how you answer the
                questions. If you’re still feeling overwhelmed, don’t suffer in
                silence.
                <a
                  href="https://wellness.carleton.ca/get-help-now/"
                  target="_blank"
                  class="text-link-blue dark:text-link-light-blue font-bold"
                  >Reach out for assistance</a
                >
                - we're here to help!
              </p>
            </div>
            <div v-on:click="startNavigator">
              <button class="nextButtonInfo">
                Get Started
                <span class="arrow">
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                      fill="#8380A8"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <Acknowledgements />
          </div>
        </div>
      </div>

      <div style="text-align: center">
        <span
          class="dot"
          :class="{ currentSlide: infoOptions[0] === true }"
        ></span>
        <span
          class="dot"
          :class="{ currentSlide: infoOptions[1] === true }"
        ></span>
        <span
          class="dot"
          :class="{ currentSlide: infoOptions[2] === true }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import Acknowledgements from "./Acknowledgements.vue";
export default {
  name: "Loader",
  data: function () {
    return {
      infoOption: false,
      infoOptions: { 0: true, 1: false, 2: false },
    };
  },
  components: {
    Acknowledgements,
  },
  methods: {
    InfoClicked() {
      this.infoOption = true;
    },
    startNavigator() {
      store.commit("updatePage", '["questionOne"]');
    },
    InfoClosed() {
      this.infoOption = false;
      this.infoOptions[0] = true;
      this.infoOptions[1] = false;
      this.infoOptions[2] = false;
    },

    nextInfoOption() {
      if (this.infoOptions[0] === true) {
        this.infoOptions[0] = false;
        this.infoOptions[1] = true;
      } else {
        this.infoOptions[1] = false;
        this.infoOptions[2] = true;
      }
    },
  },
};
</script>

<style></style>
